<template>
  <v-card
    class="mt-2"
    loader-height="8"
    :loading="admin.attributesLoading"
    :disabled="admin.attributesLoading"
    min-width="600"
    :min-height="minCardHeight"
  >
    <v-toolbar color="blue" class="text-h4 text-uppercase" dark>
      Attribute Values
      <v-spacer></v-spacer>
      <v-icon>{{ app.systemIcon }}</v-icon>
    </v-toolbar>
    <v-card-text>
      <attribute-value-list class="pb-6"></attribute-value-list>
      <attribute-value-edit
        v-show="admin.selectedAttributeValue != null"
      ></attribute-value-edit>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';
  import AttributeValueEdit from '@/components/attribute/details/AttributeValueEdit.vue';
  import AttributeValueList from '@/components/attribute/details/AttributeValueList.vue';

  export default {
    components: { AttributeValueList, AttributeValueEdit },
    props: {
      minCardHeight: Number
    },
    data() {
      return {};
    },
    computed: {
      ...mapState(['app', 'admin'])
    }
  };
</script>
